import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUseCasePossibleFit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 14,
		height: 14,
		rx: 2,
		fill: "#FFAE63"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.46484 7.29489L5.959 8.78905L9.53711 5.21094",
		stroke: "white",
		strokeWidth: 1.20425,
		strokeLinecap: "round"
	})]
});
export default SvgUseCasePossibleFit;
